import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute right-3 top-3 flex items-center space-x-2" }

import {
  ref, onMounted, onBeforeUnmount, Ref,
} from 'vue';
import Icon from '@/components/ui/Icon.vue';

interface Props {
  onClose: () => void;
}

type Rect = {
  minX: number;
  maxX: number;
  minY: number;
  maxY: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistsPopoverActions',
  props: {
    onClose: { type: Function }
  },
  setup(__props: any) {

const props = __props as {
  onClose: () => void;
};

/* eslint-disable no-param-reassign */


const dragHandleRef: Ref<{ svg: SVGSVGElement | null } | null> = ref(null);
const dragging = ref(false);
const prev = ref({ x: 0, y: 0 });
const delta = ref({ x: 0, y: 0 });
const initial = ref({ x: 0, y: 0 });

const limits: Ref<Rect | null> = ref(null);

// eslint-disable-next-line @typescript-eslint/no-shadow
const calcDelta = ({ x, y, limits }: { x: number; y: number; limits: Rect | null }) => {
  if (!limits) {
    return { x, y };
  }

  const {
    minX, maxX, minY, maxY,
  } = limits;

  return {
    x: Math.min(Math.max(x, minX), maxX),
    y: Math.min(Math.max(y, minY), maxY),
  };
};

const startDragging = (event: MouseEvent | TouchEvent) => {
  const target = document.getElementById('checklists-popover');
  if (!target) return;

  dragging.value = true;
  const source = (event instanceof TouchEvent ? event.touches[0] : event) as MouseEvent;
  const { clientX, clientY } = source;

  initial.value = { x: clientX, y: clientY };

  target.style.willChange = 'transform';

  const {
    left, top, width, height,
  } = target.getBoundingClientRect();

  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  const scrollbarHeight = window.innerHeight - document.documentElement.clientHeight;

  limits.value = {
    minX: -left + delta.value.x,
    maxX: window.innerWidth - width - left - scrollbarWidth + delta.value.x,
    minY: -top + delta.value.y,
    maxY: window.innerHeight - height - top - scrollbarHeight + delta.value.y,
  };

  if (dragHandleRef.value?.svg) {
    dragHandleRef.value.svg.classList.add('cursor-grabbing');
    dragHandleRef.value.svg.classList.remove('cursor-grab');
  }
};

const reposition = (event: MouseEvent | TouchEvent) => {
  if (!dragging.value) return null;

  const target = document.getElementById('checklists-popover');
  if (!target) return null;

  const source = (event instanceof TouchEvent ? event.changedTouches[0] : event) as MouseEvent;
  const { clientX, clientY } = source;
  const x = clientX - initial.value.x + prev.value.x;
  const y = clientY - initial.value.y + prev.value.y;

  const newDelta = calcDelta({
    x,
    y,
    limits: limits.value,
  });
  delta.value = newDelta;

  target.style.transform = `translate(${newDelta.x}px, ${newDelta.y}px)`;

  return newDelta;
};

const stopDragging = (event: MouseEvent | TouchEvent) => {
  if (!dragging.value) return;

  const target = document.getElementById('checklists-popover');
  if (!target) return;

  dragging.value = false;
  prev.value = { ...delta.value }; // Update prev with the current delta values
  target.style.willChange = '';

  if (dragHandleRef.value?.svg) {
    dragHandleRef.value.svg.classList.add('cursor-grab');
    dragHandleRef.value.svg.classList.remove('cursor-grabbing');
  }
};

onMounted(() => {
  const handle = dragHandleRef.value?.svg;

  handle?.addEventListener('mousedown', startDragging, { passive: true });
  handle?.addEventListener('touchstart', startDragging, { passive: true });

  document.addEventListener('mousemove', reposition, { passive: true });
  document.addEventListener('touchmove', reposition, { passive: true });
  document.addEventListener('mouseup', stopDragging);
  document.addEventListener('touchend', stopDragging);
});

onBeforeUnmount(() => {
  const handle = dragHandleRef.value?.svg;

  handle?.removeEventListener('mousedown', startDragging);
  handle?.removeEventListener('touchstart', startDragging);

  document.removeEventListener('mousemove', reposition);
  document.removeEventListener('touchmove', reposition);
  document.removeEventListener('mouseup', stopDragging);
  document.removeEventListener('touchend', stopDragging);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Icon, {
      ref_key: "dragHandleRef",
      ref: dragHandleRef,
      type: "drag-handle",
      class: "w-4 h-4 cursor-grab"
    }, null, 512),
    _createVNode(Icon, {
      type: "close",
      class: "cursor-pointer w-4 h-4",
      onClick: props.onClose
    }, null, 8, ["onClick"])
  ]))
}
}

})